module.exports = __webpack_public_path__ + "static/media/Moglan_DEMO.bb37aa4c.ttf";